// extracted by mini-css-extract-plugin
module.exports = {"flowableUnitSearch":"src-components-flowable-FlowableUnitSearch-styles___flowableUnitSearch"};